import { platformSelectorMiddlewares } from './platform-selector/platform-selector.middlewares';
import {platformStatusMiddleware} from "@domain/platform/status/platform-status.middlewares";

export * from './platform.constants';
export { ALL_ACCOUNTS_OPTION } from './platform-selector/platform-selector.constants';

export const platformMiddlewares = [
    platformSelectorMiddlewares,
    platformStatusMiddleware
];
